import { render, staticRenderFns } from "./FormularioManualView.vue?vue&type=template&id=219aecae&"
import script from "./FormularioManualView.vue?vue&type=script&lang=ts&"
export * from "./FormularioManualView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports